import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { OffersCar } from '../../../containers/offers/OffersCar'
import { SignalRProvider } from 'brokertslib/src/context/SignalRProvider';
import { WithOffer } from '../../../containers/hoc/WithOffer'
import { WithAuth } from '../../../containers/hoc/WithAuth'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'
import { Loading } from '../../../components/Loading'
import { useNavigate } from 'react-router-dom'

const baseUrl = process.env.PUBLIC_URL
const hubUrl = process.env.REACT_APP_CALCULATION_HUB
const url = `${baseUrl}/${hubUrl}`

const _Step3 = () => {
  const navigate = useNavigate()
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParamsContext()

  if (!isLoadingData && insuranceParams && (insuranceParams.generalParams?.lastWizardStep ?? 1) < 2) {
    navigate('/carkulka/wizard/too-far', { replace: true })
  }

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) &&
          <StepsContent step={3}>
            <SignalRProvider url={url}>
              <Steps icon="car" />

              <InsuranceInfo />

              <OffersCar />
            </SignalRProvider>
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step3 =
  WithOffer(WithAuth(_Step3))